import { QRUrlStatic } from "./qr-url-static";
export { QRUrlStatic };
